import React from "react";

// Sport emoji mapping (single source; SportIcon falls back to 🎮)
const SPORT_EMOJI: Record<string, string> = {
  Soccer: "⚽",
  Football: "🏈",
  "American Football": "🏈",
  "Rugby Union": "🏉",
  "Rugby League": "🏈",
  Baseball: "⚾",
  Basketball: "🏀",
  Cricket: "🏏",
  Tennis: "🎾",
  "Ice Hockey": "🏒",
  Golf: "🏌️",
  Volleyball: "🏐",
  Boxing: "🥊",
  Handball: "🤾",
};

export const getSportEmoji = (sport: string): string =>
  SPORT_EMOJI[sport] ?? "";

export const SportIcon: React.FC<{ sport: string }> = ({ sport }) => {
  const emoji = getSportEmoji(sport) || "🎮";
  return <span>{emoji}</span>;
};
